// Integration Task panding
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Medicinetypemodel } from '../../models'

export interface MedicinetypeState {
    Medicinetype: Medicinetypemodel
    MedicinetypeList: Medicinetypemodel[]
}

const initialState: MedicinetypeState = {
    Medicinetype: {
        MedicinetypeID: 0,
        MedicinetypeName: '',
        Packageunit: '',
        Packagetype: '',
        Sellunit: '',
        Compositiontype: '',
    },
    MedicinetypeList: [],
}

export const MedicinetypeSlice = createSlice({
    name: 'Medicinetype',
    initialState,
    reducers: {
        setType: (state, action: PayloadAction<Medicinetypemodel[]>) => {
            state.MedicinetypeList = action.payload
        },

        getType: (state, action: PayloadAction<number>) => {
            let id = action.payload
            let model: Medicinetypemodel = initialState.Medicinetype
            if (id > 0) {
                let currentList: Medicinetypemodel[] = state.MedicinetypeList
                model = currentList.find((c) => c.MedicinetypeID === id) || initialState.Medicinetype
            }
            state.Medicinetype = model
        },
    },
})

export const {
    setType,
    getType,
} = MedicinetypeSlice.actions

export default MedicinetypeSlice.reducer
